import api from './index'
import type { ApiResponse, Issue, IssueStatus, IssuePriority } from '@/types'

export const getIssues = async (projectKey: string): Promise<ApiResponse<{ issues: Issue[] }>> => {
  const response = await api.get(`/projects/${projectKey}/issues`)
  return response.data
}

export const getProjectIssues = async (projectId: string): Promise<ApiResponse<{ issues: Issue[] }>> => {
  const response = await api.get(`/projects/id/${projectId}/issues`)
  return response.data
}

export const getIssue = async (issueId: string): Promise<ApiResponse<{ issue: Issue }>> => {
  const response = await api.get(`/issues/${issueId}`)
  return response.data
}

export const createIssue = async (issueData: {
  title: string
  description?: string
  projectId: string
  assigneeId?: string
  priority: IssuePriority
}): Promise<ApiResponse<{ issue: Issue }>> => {
  const response = await api.post('/issues', issueData)
  return response.data
}

export const updateIssue = async (
  issueId: string,
  updateData: Partial<{
    title: string
    description: string
    status: IssueStatus
    priority: IssuePriority
    assigneeId: string | null
    position: number
    dueDate: string | null
  }>
): Promise<ApiResponse<{ issue: Issue }>> => {
  const response = await api.put(`/issues/${issueId}`, updateData)
  return response.data
}

export const deleteIssue = async (issueId: string): Promise<ApiResponse> => {
  const response = await api.delete(`/issues/${issueId}`)
  return response.data
}

export const archiveIssue = async (issueId: string, archived: boolean): Promise<ApiResponse<{ issue: Issue }>> => {
  const response = await api.patch(`/issues/${issueId}/archive`, { archived })
  return response.data
}

export const getArchivedIssues = async (projectId: string): Promise<ApiResponse<{ issues: Issue[] }>> => {
  const response = await api.get(`/issues/archived/${projectId}`)
  return response.data
}

export const getDeletedIssues = async (projectId: string): Promise<ApiResponse<{ issues: Issue[], retentionDays: number }>> => {
  const response = await api.get(`/issues/trash/${projectId}`)
  return response.data
}

export const restoreIssue = async (issueId: string): Promise<ApiResponse<{ issue: Issue }>> => {
  const response = await api.patch(`/issues/${issueId}/restore`)
  return response.data
}

export const permanentlyDeleteIssue = async (issueId: string): Promise<ApiResponse> => {
  const response = await api.delete(`/issues/${issueId}/permanent`)
  return response.data
}

export const moveIssue = async (
  issueId: string,
  targetProjectId: string
): Promise<ApiResponse<{ issue: Issue }>> => {
  const response = await api.post(`/issues/${issueId}/move`, { targetProjectId })
  return response.data
}